import { EventEmitter } from '@angular/core';

export class CpqNumberOptions {
    
    constructor(options?: Partial<CpqNumberOptions>) {
        this.allowDecimal = options?.allowDecimal ?? true;
        this.minValue = options?.minValue ?? 0;
        this.maxValue = options?.maxValue ?? Number.MAX_SAFE_INTEGER;
        this.includeMinValue = options?.includeMinValue ?? true;
        this.includeMaxValue = options?.includeMaxValue ?? true;
      }
    
    public onPropertyChange: EventEmitter<{ propertyName: string, propertyValue: any }> = new EventEmitter<{ propertyName: string, propertyValue: any }>();
    private internalAllowDecimal?: boolean;
    private internalMinValue?: number;
    private internalMaxValue?: number;
    /** Example: minValue === 17 ,if true =>  then array is:[17,18,..maxValue] if false => then array is: [18,19,...maxValue]  */
    private internalIncludeMinValue?: boolean;
    /** Example: maxValue === 17 ,if true =>  then array is:[minValue,..maxValue] if false => then array is: [minValue,..maxValue - 1]  */
    private internalIncludeMaxValue?: boolean;

    public get allowDecimal(): boolean {
        return this.internalAllowDecimal;
    }
    public set allowDecimal(value: boolean) {
        this.internalAllowDecimal = value;
        this.onPropertyChange.emit({propertyName: 'allowDecimal', propertyValue: value});
    }
    
    public get minValue(): number {
        return this.internalMinValue;
    }    
    public set minValue(value: number) {
        this.internalMinValue = value;
        this.onPropertyChange.emit({propertyName: 'minValue', propertyValue: value});
    }    
    
    public get maxValue(): number {
        return this.internalMaxValue;
    }    
    public set maxValue(value: number) {
        this.internalMaxValue = value;
        this.onPropertyChange.emit({propertyName: 'maxValue', propertyValue: value});
    }
    
    public get includeMinValue() : boolean {
        return this.internalIncludeMinValue;
    }    
    public set includeMinValue(value : boolean) {
        this.internalIncludeMinValue = value;
        this.onPropertyChange.emit({propertyName: 'includeMinValue', propertyValue: value});
    }
    
    public get includeMaxValue() : boolean {
        return this.internalIncludeMaxValue;
    }
    public set includeMaxValue(value : boolean) {
        this.internalIncludeMaxValue = value;
        this.onPropertyChange.emit({propertyName: 'includeMaxValue', propertyValue: value});
    }
}